export default "__VITE_ASSET__1iSFSPFc__"